import { render, staticRenderFns } from "./newBrands.vue?vue&type=template&id=e67f5310&scoped=true"
import script from "./newBrands.vue?vue&type=script&lang=js"
export * from "./newBrands.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/newBrands.css?vue&type=style&index=0&id=e67f5310&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67f5310",
  null
  
)

export default component.exports